/*
* Тултип события календаря
*
* В чипе стоит только номер, название показывается по наведению. FullCalendar
* рисует события сам, поэтому вместо нативного `title` держим один VTooltip
* и переставляем его активатор на элемент под курсором.
*/

export const useCalendarEventTooltip = () => {
  const hoveredEvent = ref<{ el: HTMLElement; title: string } | null>(null)

  const onEventMouseEnter = (arg: { el: HTMLElement; event: { title: string } }) => {
    hoveredEvent.value = { el: arg.el, title: arg.event.title }
  }

  const onEventMouseLeave = () => {
    hoveredEvent.value = null
  }

  return { hoveredEvent, onEventMouseEnter, onEventMouseLeave }
}
